import React, { Component } from 'react';
import queryString from 'query-string';
import { Icon, Toast } from 'antd-mobile';
import styles from './styles.module.less';
import { getImAppId, getImOpenId, getOrderList } from '../../service/chat-service';
import tools from '../../utils/tools';

import orderEmpty from './empty_order.png';
import gerenBg from './gerenBg.png';
// import rankings from '../../public/images/head.png';

const homeImage = {
  backgroundSize: '100% 100%', // 记得这里100%
  // background: `url(${homeImage})`,
  // 或者下面这种也行
  backgroundImage: `url(${gerenBg})`,
};
/**
 * 支付张泰
 */
const payStatus = {
  0: '待付款',
  2: '已付款',
  3: '已退货',
};

// 个人中心
class index extends Component {
  end = false

  constructor(props) {
    super(props);
    this.state = {
      pageNum: 1,
      pageSize: 10,
      dataList: [],
      loading: false,
      userInfo: {},
    };
  }

  componentDidMount() {
    document.title = '个人中心';
    this.loadData();
    this.addScrollEvent();
    this.getLiveOpenId(); // 微信授权上线前打开
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  /**
   * 微信授权
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const WXCode = queryString.parse(windowHref).code;
    if (!WXCode) {
      localStorage.clear();
      try {
        const { code, data, message } = await getImAppId();
        if (process.env.REACT_APP_API_ENV === 'local') {
          // 本地测试时不走微信验证
          this.getUserInfo('oQd0LwJcSPgP7eYwSy38bUdb793A');
        } else if (code === 10000) {
          window.location.href = tools.toWxth(data);
        } else {
          Toast.show(message || '获取微信 appId 失败');
        }
      } catch (e) {
        Toast.show('获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('openId')) {
      try {
        const { code, data } = await getImOpenId(WXCode, 1);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          this.setState({
            userInfo: data,
          });
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getUserInfo(localStorage.getItem('openId'));
    }
  }

  loadData = async (pageNum2) => {
    const { pageNum } = this.state;
    const pageNum1 = pageNum2 || pageNum;
    const { pageSize, dataList } = this.state;

    if (this.end) return false;
    this.setState({ loading: true });

    try {
      const { list } = (await getOrderList(pageNum1, pageSize)) || {};

      let orderList = dataList;
      if (Array.isArray(list) && list.length) {
        if (list.length < pageSize) this.end = true;
        orderList = dataList.concat(list);
      }
      this.setState({ dataList: orderList, pageNum: pageNum1, loading: false });
    } catch (e) {
      Toast.show(e.message);
      this.setState({ loading: false });
    }
    return true;
  }

  scrollBottomLoad = () => {
    const { pageNum, loading } = this.state;
    if (this.end || loading) return false;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const bodyHeight = document.getElementById('order_content_H9').clientHeight;
    const { clientHeight } = document.documentElement;

    if (scrollTop + clientHeight + 50 >= bodyHeight) {
      this.loadData(pageNum + 1);
    }
    return true;
  }

  addScrollEvent = () => {
    window.addEventListener('scroll', this.scrollBottomLoad);
  }

  removeScrollEvent = () => window.removeEventListener('scroll', this.scrollBottomLoad)

  renderOrderList = () => {
    const { dataList } = this.state;
    return dataList.map((item) => (
      <div className={styles.orderItem} key={item.orderId}>
        {/* 标题 */}
        <div className={styles.header}>
          <span>
            订单编号：
            <span>{item.orderId}</span>
          </span>
          <span className={styles.sendStatus}>{payStatus[item.status]}</span>
        </div>
        {/* 详情 */}
        <div className={styles.detail}>
          <div className={styles.left}>
            <img src={item.productImg} alt="" />
          </div>
          <div className={styles.right}>
            <p>{item.productName}</p>
            <p className={styles.money}>
              ¥
              {' '}
              {item.orderAmount ? (item.orderAmount / 100).toFixed(2) : '0:00'}
            </p>
            <div className={styles.bottom}>
              {item.specificationName && (
                <span>
                  已选&quot;
                  {item.specificationName}
                  &quot;
                </span>
              )}
              <span className={styles.buyNumber}>
                x
                {item.orderNum}
              </span>
            </div>
          </div>
        </div>
        {/* 快递单号 */}
        {item.expressNo && (
          <div className={styles.header}>
            <span>
              {item.expressCom}
              ：
              {item.expressNo}
            </span>
          </div>
        )}
      </div>
    ));
  }

  renderEmpty = () => (
    <div className={styles.emptyContent}>
      <img src={orderEmpty} alt="" />
      <p className={styles.notice}>暂无订单</p>
    </div>
  )

  render() {
    const { dataList, loading, userInfo } = this.state;
    console.log(userInfo);
    return (
      <div className={styles.orderContent} id="order_content_H9">
        <div className={styles.WxUserInfo} style={homeImage}>
          <div>
            <img src={userInfo.headimgurl} alt="" />
            <span>{userInfo.nickname}</span>
          </div>
        </div>
        {dataList.length ? this.renderOrderList() : this.renderEmpty()}
        {loading && (
          <div className={styles.loading}>
            <Icon type="loading" />
          </div>
        )}
      </div>
    );
  }
}

export default index;
